import { render, staticRenderFns } from "./SpeakersSettings.vue?vue&type=template&id=776e0cd6&"
import script from "./SpeakersSettings.vue?vue&type=script&lang=js&"
export * from "./SpeakersSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports